const MOBILE_BREAKPOINT = 1024;

function initMenuBlock(scope = document) {
    const root = scope && scope.querySelectorAll ? scope : document;
    const stickyMenus = root.querySelectorAll(".js-menu-sticky-below-header");
    const mobileCarouselMenus = root.querySelectorAll(".menu--mobile-carousel");

    const body = document.body;
    const header = document.querySelector(".header");

    const applyMobileCarouselState = () => {
        mobileCarouselMenus.forEach((menu) => {
            const track = menu.querySelector(".procedures");
            const list = menu.querySelector(".procedures ul");
            if (!list || !track) return;
            const arrowsEnabled = menu.getAttribute("data-mobile-carousel-arrows") !== "false";

            let prevButton = menu.querySelector(".menu-carousel-arrow--prev");
            let nextButton = menu.querySelector(".menu-carousel-arrow--next");

            if (arrowsEnabled && (!prevButton || !nextButton)) {
                prevButton = document.createElement("button");
                nextButton = document.createElement("button");
                prevButton.type = "button";
                nextButton.type = "button";
                prevButton.className = "menu-carousel-arrow menu-carousel-arrow--prev";
                nextButton.className = "menu-carousel-arrow menu-carousel-arrow--next";
                prevButton.setAttribute("aria-label", "Scroll menu left");
                nextButton.setAttribute("aria-label", "Scroll menu right");
                menu.appendChild(prevButton);
                menu.appendChild(nextButton);
            }

            if (!arrowsEnabled) {
                if (prevButton) prevButton.remove();
                if (nextButton) nextButton.remove();
            }

            const updateArrowState = () => {
                const maxScroll = list.scrollWidth - track.clientWidth;
                const isOverflowing = maxScroll > 2;
                const atStart = track.scrollLeft <= 2;
                const atEnd = track.scrollLeft >= maxScroll - 2;

                track.classList.toggle("has-carousel-overflow", isOverflowing);
                if (prevButton) prevButton.disabled = atStart;
                if (nextButton) nextButton.disabled = atEnd;
            };

            if (prevButton && nextButton) {
                prevButton.onclick = () => {
                    track.scrollBy({ left: -Math.max(140, track.clientWidth * 0.5), behavior: "smooth" });
                };
                nextButton.onclick = () => {
                    track.scrollBy({ left: Math.max(140, track.clientWidth * 0.5), behavior: "smooth" });
                };
            }

            const isMobileLike = window.innerWidth <= MOBILE_BREAKPOINT || menu.clientWidth <= MOBILE_BREAKPOINT;

            if (isMobileLike) {
                if (!track.dataset.carouselArrowsBound) {
                    track.addEventListener("scroll", updateArrowState, { passive: true });
                    track.dataset.carouselArrowsBound = "true";
                }
                requestAnimationFrame(updateArrowState);
            } else {
                track.classList.remove("has-carousel-overflow");
                if (prevButton) prevButton.disabled = true;
                if (nextButton) nextButton.disabled = true;
            }
        });
    };

    const updateMenuStickyState = () => {
        if (!stickyMenus.length) return;

        const isHeaderSticky =
            body.classList.contains("sticky-menu") ||
            (header && window.getComputedStyle(header).position === "fixed");
        const headerHeight = header ? header.getBoundingClientRect().height : 0;

        stickyMenus.forEach((menu) => {
            if (!menu.dataset.originalHeight) {
                menu.dataset.originalHeight = String(menu.offsetHeight || 0);
            }

            if (isHeaderSticky) {
                menu.classList.add("is-sticky-below-header-active");
                menu.style.setProperty("--menu-sticky-top", `${headerHeight}px`);
                menu.style.height = `${menu.dataset.originalHeight}px`;
            } else {
                menu.classList.remove("is-sticky-below-header-active");
                menu.style.removeProperty("--menu-sticky-top");
                menu.style.removeProperty("height");
            }
        });
    };

    const recalcHeights = () => {
        stickyMenus.forEach((menu) => {
            const wasActive = menu.classList.contains("is-sticky-below-header-active");
            if (wasActive) {
                menu.classList.remove("is-sticky-below-header-active");
                menu.style.removeProperty("height");
            }
            menu.dataset.originalHeight = String(menu.offsetHeight || 0);
            if (wasActive) {
                menu.classList.add("is-sticky-below-header-active");
                menu.style.height = `${menu.dataset.originalHeight}px`;
            }
        });

        updateMenuStickyState();
    };

    applyMobileCarouselState();
    updateMenuStickyState();

    window.addEventListener("scroll", updateMenuStickyState, { passive: true });
    window.addEventListener("resize", () => {
        applyMobileCarouselState();
        recalcHeights();
    });
    window.addEventListener("orientationchange", applyMobileCarouselState);
}

document.addEventListener("DOMContentLoaded", () => {
    initMenuBlock(document);

    if (window.acf) {
        window.acf.addAction("render_block_preview/type=menu", (el) => {
            initMenuBlock(el[0] || el);
        });
    }
});
